import { getRoutes } from '@ui-framework/index';
import AuthorizationWrapper, {
  authFnAllowOnlySAForMaintenance,
} from '@product-framework/components/AuthorizationWrapper';
import ServiceAdministratorClientEdit from './pages/edit/index';
import ServiceAdministratorClientCreate from './pages/create/index';
import ServiceAdministratorClientList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import ServiceAdministratorClientFormStore from './store/index';

const Pages = ProtectedRoute => ({
  ServiceAdministratorClientEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorClientEdit}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
  ServiceAdministratorClientCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorClientCreate}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
  ServiceAdministratorClientList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorClientList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    serviceadministratorclientFormStore:
      new ServiceAdministratorClientFormStore(rootStore),
  },
];

export {
  ServiceAdministratorClientEdit,
  ServiceAdministratorClientCreate,
  ServiceAdministratorClientList,
  routes,
  stores,
};
